import "core-js/modules/es.function.name.js";
import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-91f0eb38"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "mvList"
};
var _hoisted_2 = {
  class: "alonePlay-playlist"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  key: 0,
  class: "songe"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "animatIcon"
  }, [/*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-play"
  })], -1
  /* HOISTED */
  );
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_image = _resolveComponent("el-image");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createCommentVNode(" 每个item "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mvList, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['alone-play-item', _ctx.isUnderLine && 'active']),
      key: item.id,
      onClick: function onClick($event) {
        return _ctx.mvClick(item.id);
      }
    }, [_createVNode(_component_el_image, {
      fit: "fill",
      src: item.sPicUrl || item.picUrl
    }, null, 8
    /* PROPS */
    , ["src"]), _createElementVNode("p", {
      class: _normalizeClass(['paylist-item-title', _ctx.isBlod ? 'linelittle' : 'morelittle', _ctx.isBlod && 'blod'])
    }, _toDisplayString(item.name), 3
    /* TEXT, CLASS */
    ), _ctx.isSonger ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.isSonger[index]), 1
    /* TEXT */
    )) : _createCommentVNode("v-if", true), _hoisted_5], 10
    /* CLASS, PROPS */
    , _hoisted_3);
  }), 128
  /* KEYED_FRAGMENT */
  ))])]);
}